import { AssetInfo } from './../../../models/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { ApiService } from 'src/app/providers/api.service';
import { Component, Inject, OnInit, OnDestroy, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BuisnessPromotion } from 'src/app/models/common';
import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
declare var google: any;

@Component({
  selector: 'sm-add-edit-owner-profile',
  templateUrl: './add-edit-owner-profile.component.html',
  styleUrls: ['./add-edit-owner-profile.component.scss']
})
export class AddEditOwnerProfileComponent implements OnInit, OnDestroy {
  date = new FormControl();
  salaryData: any = []
  maxDate: Date = new Date()
  profileData:any = {}
  uploadedImage:any = {}
  public newSalaryData: any = {
    hash_id:null,
    amount: null,
    workingDays: null,
    paidLeave: null,
    unPaidLeave: null,
    salaryType: null,
    notes: null,
    salaryFromDate: null,
    salaryToDate: null,
    salary_credit_date: null,
    payType: 1,
    paidOn: 1,
    netPayment: null,
    otherPerks: null,
    deduction: null,
  }
  public editCreditData: any = {
    amount: null,
    status: 1
  }
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public loader: boolean = false;
  private _assetInfo: AssetInfo[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private _ngZone: NgZone,
    private loaderservice: LoaderServiceService,
    private activemodal: MatDialogRef<AddEditOwnerProfileComponent>
  ) {}

  removeAsset(index: any) {
    console.log(index);
    this.assetList.splice(index, 1);
  }

  ngOnInit(): void {
    setTimeout(() => {
      if (typeof google !== 'undefined' && google.maps && google.maps.places) {
      this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
        this.geocoder = new google.maps.Geocoder();
      } else {
        console.error('Google Maps API not loaded');
      }
    }, 1000);
    console.log(this.parentData);
    this.profileData.name = this.parentData.data.name
    this.profileData.email = this.parentData.data.email && this.parentData.data.email != 'null' ? this.parentData.data.email : null
    this.profileData.dateOfBirth = this.parentData.data.dateOfBirth
    this.profileData.toshowPhone = this.parentData.data.country_code + ' ' + this.parentData.data.phone
    this.profileData.phone = this.parentData.phone
    this.profileData.gender = this.parentData.data.gender
    this.profileData.shortBio = this.parentData.data.shortBio && this.parentData.data.shortBio != 'null'  ? this.parentData.data.shortBio : '' 
    this.profileData.profileThumbImg = this.parentData.data.profileThumbImg
    this.profileData.profileThumbImgReal = this.parentData.data.profileThumbImg
    this.profileData.profileImg = this.parentData.data.profileImg
    this.profileData.addressInfo = JSON.parse(JSON.stringify(this.parentData.data.addressInfo));
      // if(!data.editMode){
      //   this.loader = true;
      //   this.loaderservice.showLoader = true
      //   this._apiService.getOnlySalaryInfo(data.employeeHash, '1')
      // }
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        this.uploadedImage = {}
        console.log(res.result.url);
        this._ngZone.run(() => {
          this.uploadedImage.imgUrl = res.result?.url
          this.uploadedImage.thumbnail = res.result?.thumbnail

          this.profileData.profileThumbImg = res.result?.url
          this.profileData.profileThumbImgReal = res.result?.thumbnail

          this.profileData.profileImg = res.result?.url
          this.loaderservice.showLoader = false
        });
        // this.newSalaryData.imgUrl = res.result?.url;fff
      }
      // if(res.responseType === SM_CONSTANTS.RESULT_API_GET_SALARY_INFO_ONLY){
      //   this.salaryData = []
      //   if(res.result){
      //     this.newSalaryData.amount = res.result[0].netPayment
      //     this.newSalaryData.deduction = res.result[0].deduction
      //     this.newSalaryData.otherPerks = res.result[0].otherPerks
      //     this.newSalaryData.netPayment = res.result[0].netPayment + res.result[0].otherPerks - res.result[0].deduction
      //     this.newSalaryData.paidOn = res.result[0].paidOn
      //     this.newSalaryData.payType = res.result[0].payType
          
      //   }
      //   this.loader = false;
      //   this.loaderservice.showLoader = false
      // }
      if (res.responseType === SM_CONSTANTS.RESULT_API_UPDATE_USER_PROFILE) {
        if(res.result){
          
          // this.loaderservice.showLoader = false
          this.activemodal.close()
        }
      
      }
    });
  }

  fileSelected(event: any) {
    // Handle the file selection here
    const selectedFile = event.target.files[0];
    console.log('File selected:', selectedFile ? selectedFile.name : 'None');
  }

  assetType: number = 0
  onUploadImage(event: any) {
    this.assetType = 0
    console.log(event);
    console.log(event.target);
    
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;

    if (this.fileName.includes(' ')) {
      this.fileName = this.fileName.replace(/\s+/g, '_');
    }
    let sizeinKb = +event.target.files[0].size / 1000;
    // if (sizeinKb > 1021) {
    //   this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
    //   return;
    // }
    let extension = this.fileName.substring(this.fileName.lastIndexOf('.') + 1);
    const mimeType = event.target.files[0].type;
    console.log(extension);
    // this.assetList.push({
    //   assetName: this.fileName,
    // });
    this.loader = true;
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    
    if (mimeType.startsWith('image/')) {
      console.log('image');
      if (sizeinKb > 5120) {
        this.loader = false;
        this._snackBar.open(
          'Image size should not exceed more then 1 mb',
          'Ok'
        );
        return;
      }
      this.assetType = 1
      this.loaderservice.showLoader = true
      this._apiService.uploadAssets(formData, 2);
      return;
    }
    if (mimeType.startsWith('video/')) {
      console.log('Video');
      if (sizeinKb > 15360) {
        // this.loader = false;
        this._snackBar.open(
          'Image size should not exceed more then 1 mb',
          'Ok'
        );
        return;
      }
      this.assetType = 2
      this.loaderservice.showLoader = true
      this._apiService.uploadAssets(formData, 3);
      return;
    }
    this.loader = false;
    this._snackBar.open('File format not supported', 'Ok');
  }
  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
  this.profileData.addressInfo.addressLine = this.profileData?.addressInfo?.address_line ?? ''
    let data = {
      profileInfo: {
        profileHashId: this.parentData.data.profileHashId,
        name: this.profileData.name,
        email: this.profileData.email && this.profileData.email != 'null' &&  this.profileData.email != ''  ? this.profileData.email : null ,
        countryCode: this.parentData.data.country_code,
        phone: this.parentData.data.phone,
        gender: this.profileData.gender,
        shortBio: this.profileData.shortBio,
        dob: this.profileData.dateOfBirth? this.formatDate((new Date(this.profileData.dateOfBirth)).toLocaleDateString()):null,
        userType: this.parentData.data.userType,
        searchType: 1,
        isPrivate: this.parentData.data.isPrivate,
        addressInfo: this.profileData.addressInfo,
        assetInfo: {
          thumbImgUrl: this.profileData.profileThumbImgReal,
          imgUrl:this.profileData.profileImg
        },
          origin: 'business'

      }
    }

    console.log(data);
    
    this.loaderservice.showLoader = true
    this._apiService.updateUserProfile(data)

   
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split('/');
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);
  
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, '0');
  
    return `${yyyy}-${mm}-${dd}`;
  }

  formatDateForEdit(originalDate: string) {
    const date = new Date(originalDate);
    
    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getUTCDate()).padStart(2, '0');
  
    return `${yyyy}-${mm}-${dd}`;
  }

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value ?? moment();
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    console.log(ctrlValue);
    
    this.date.setValue(ctrlValue);
    console.log(this.date.value._d);
    
    datepicker.close();
  }

  changeRates(){
    this.newSalaryData.netPayment = +this.newSalaryData.amount + +this.newSalaryData.otherPerks - +this.newSalaryData.deduction
  }


    /**LOCATION AUTOCOMPLETE FUNCTION */
  GoogleAutocomplete: any;
  geocoder: any;
  autocompleteItems: any = [];
  selectedLocation: any = [];
  formattedAddress: any;
  lat: any;
  lng: any;
  updateSearchResults() {
    console.log('Text enter', this.profileData.addressInfo.address_line);
    if (
      this.profileData.addressInfo.address_line == '' ||
      this.profileData.addressInfo.address_line == null
    ) {
      this.autocompleteItems = [];
      return;
    }
    this.GoogleAutocomplete.getPlacePredictions(
      {
        input: this.profileData.addressInfo.address_line,
      },
      (predictions: any, status: any) => {
        console.log(predictions, status);
        this.autocompleteItems = [];
        predictions.forEach((prediction: any) => {
          this.autocompleteItems.push(prediction);
        });
      }
    );
  }
  selectSearchResult(item: any) {
      console.log(item);
      this.autocompleteItems = [];
      this.geocoder.geocode(
        {
          placeId: item.place_id,
        },
        (results: any, status: any) => {
          if (status === 'OK' && results[0]) {
            this._ngZone.run(() => {
              this.profileData.address_line = results[0].formatted_address;

              // this.locationSelected = true;
              let location_set: any = JSON.stringify(results[0].geometry);
              location_set = JSON.parse(location_set);
              let position = {
                lat: results[0].geometry.location.lat,
                lng: results[0].geometry.location.lng,
              };
              this.lat = location_set.location.lat;
              this.lng = location_set.location.lng;
              console.log(this.lat, this.lng);
              console.log('Latitude & Langitude', position);
              this.storeLocation(
                results[0].address_components,
                results[0].formatted_address,
                item.description
              );
            });
          }
        }
      );
  }
  storeLocation(location: any, formatted_address: any, description: any) {
    console.log(location);

    const selectedLocation: any = {};
    location.forEach((element: any) => {
      console.log(element, element.types.includes('postal_code'));
      if (element.types.includes('postal_code')) {
        selectedLocation.zip = element.long_name;
      } else if (element.types.includes('country')) {
        selectedLocation.country = element.long_name;
      } else if (element.types.includes('administrative_area_level_1')) {
        selectedLocation.state = element.long_name;
      } else if (element.types.includes('locality')) {
        selectedLocation.city = element.long_name;
      } else if (element.types.includes('route')) {
        selectedLocation.address = element.long_name;
      }
    });
    this.formattedAddress = description;
    this.selectedLocation = selectedLocation;
    console.log();

    this.profileData.addressInfo = {
      lat: this.lat,
      lng: this.lng,
      zip: selectedLocation.zip,
      city: selectedLocation.city,
      state: selectedLocation.state,
      country: selectedLocation.country,
      address_line: description,
    };

  }
}
